import KentuckyHeroSection from "./components/HeroSection";
import KentuckyCitiesDirectory from "./components/CitiesDirectory";
import KentuckyStateResources from "./components/StateResources";
import KentuckyFAQSection, { faqs } from "./components/FAQSection";
import KentuckyFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const kentuckyServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function KentuckyPage() {
  return (
    <>
      <CitySEOHead
        city="Kentucky"
        state="Kentucky"
        stateAbbr="KY"
        route="/states/kentucky"
        title="Kentucky Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Kentucky — Louisville, Lexington, Bowling Green, Northern Kentucky. Emergency processing as fast as 24 hours. A+ BBB rated courier service with 20+ years of experience."
        geoPlacename="Kentucky, United States"
        geoPosition="37.8393;-85.6547"
        faqs={faqs.map((f) => ({ q: f.question, a: f.answer }))}
        servicesSchema={kentuckyServices}
      />
      <div className="font-sans">
        <KentuckyHeroSection />
        <KentuckyCitiesDirectory />
        <KentuckyStateResources />
        <KentuckyFAQSection />
        <SEOCrossLinks state="KY" />
        <KentuckyFinalCTA />
      </div>
    </>
  );
}